import { lory } from 'lory.js';
import h from 'hyperscript';

const SLIDER_CONFIG = {
  rewind: true,
  slideSpeed: 1000,
  classNameFrame: 'hero-slider__inner',
  classNameSlideContainer: 'hero-slider__slides',
  classNamePrevCtrl: 'hero-slider__prev',
  classNameNextCtrl: 'hero-slider__next',
};

class HeroSlider {
  constructor($el) {
    this.$el = $el;
    this.$sliderInner = this.$el
      .querySelector('.hero-slider__inner');

    this.$slides = this.$el
      .querySelectorAll('.hero-slider__slide');

    this.initEvents();
    this.initControls();
    this.initLory();
    this.initSlideshow();
  }

  initEvents() {
    this.$el.addEventListener('after.lory.init', () => {
      this.$el.classList.add('hero-slider--initialized');
    });

    this.$el.addEventListener('before.lory.slide', () => {
      if (this.slideShowConfig.autoplay) this.stopSlideshow();
    });

    this.$el.addEventListener('after.lory.slide', () => {
      if (this.slideShowConfig.autoplay) {
        this.startSlideshow();
        this.animateDot(this.lory.returnIndex());
      }

      this.updateControls();
    });
  }

  initLory(config = SLIDER_CONFIG) {
    this.lory = lory(this.$el, config);
  }

  initControls() {
    this.$sliderInner.appendChild(
      h('.hero-slider__dots-container',
        [
          h('ul.hero-slider__dots', [...this.$slides].map(
            (_, index) => h('li.hero-slider__dot-item.hero-slider__dot', { 'data-slide-id': index, onclick: e => this.showSlide(e) },
                h('.hero-slider__dot-loader'),
              ),
            ),
          ),
        ],
      ),

    );
    // for better tabbing first child
    this.$sliderInner.insertBefore(
      h('button.hero-slider__pause', {
        attrs: {
          tabindex: 0,
          title: 'pausieren',
        },
        onclick: e => this.toggleSlideshow(e),
      }), this.$sliderInner.firstChild);

    this.$el.querySelectorAll('.hero-slider__prev, .hero-slider__next').forEach(($control) => {
      $control.addEventListener('keydown', (e) => {
        if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
          $control.click();
        }
      });
    });
  }

  updateControls() {
    this.$el.querySelectorAll('.hero-slider__dot-loader').forEach(
      ($loader) => {
        const $l = $loader;
        $l.style.width = '0%';
      },
    );
  }

  initSlideshow() {
    this.slideShowConfig = {
      autoplay: this.$el.dataset.slideshowAutoplay === 'true',
      speed: parseInt(this.$el.dataset.slideshowSpeed, 10),
    };

    if (this.slideShowConfig.autoplay) {
      this.animateDot(this.lory.returnIndex());
      this.startSlideshow();
    }
  }

  toggleSlideshow(e) {
    this.slideShowConfig.autoplay = !this.slideShowConfig.autoplay;

    if (this.slideShowConfig.autoplay) {
      e.target.classList.remove('hero-slider__pause--active');
      this.animateDot(this.lory.returnIndex());
      this.startSlideshow();
    } else {
      e.target.classList.add('hero-slider__pause--active');
      this.stopAnimation();
      this.stopSlideshow();
      this.updateControls();
    }
  }

  startSlideshow() {
    this.slideshowTimer = setInterval(() => {
      this.lory.next();
    }, this.slideShowConfig.speed);
  }

  stopSlideshow() {
    clearInterval(this.slideshowTimer);
  }

  stopAnimation() {
    clearInterval(this.animationTimer);
  }

  animateDot(index) {
    this.$nextDot = this.$el.querySelectorAll('.hero-slider__dot')[index];
    this.$loader = this.$nextDot.querySelector('.hero-slider__dot-loader');
    this.$loader.style.width = '0%';

    this.stopAnimation();
    this.animationTimer = setInterval(() => {
      const width = parseInt(this.$loader.style.width.split('%')[0], 10);
      if (width < 100) this.$loader.style.width = `${width + 1}%`;
    }, this.slideShowConfig.speed / 100);
  }

  showSlide(event) {
    this.lory.slideTo(
      parseInt(event.target.dataset.slideId, 10),
    );
  }
}

document.querySelectorAll('.hero-slider').forEach($slider => new HeroSlider($slider));



// WEBPACK FOOTER //
// ./src/components/organisms/hero-slider/hero-slider.js